import axios from './axios-instance.js';
import store from '../store';

export default () => {
  axios.interceptors.response.use((response) => {
    if (response.status !== 200) {
      // #TODO Loguer queqlque part (SENTRY ?)
    } else if (response.headers['x-access-token']) {
      store.commit('user/USER_SETTOKEN', response.headers['x-access-token']);
    }
    return response;
  });

  axios.interceptors.request.use(
    (config) => {
      if (store.state.user.token) {
        config.headers['x-access-token'] = store.state.user.token;
      }

      return config;
    },

    (error) => {
      return Promise.reject(error);
    }
  );
};



// WEBPACK FOOTER //
// ./src/tools/httpInterceptor.js